import Client from './client';

export default class BillingStatementReviews extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(options = {}) {
    return this.makeRequest(`${this.host}/internal/account/statement/reviews`, options);
  }

  putBillingAndStatementsByBillingStatementId(billingStatementId, options = {}) {
    return this.makeRequest(`${this.host}/internal/account/statement/reviews/billing/statements/${billingStatementId}`, {
      ...options,
       method: 'PUT',
    });
  }

  getById(id, options = {}) {
    return this.makeRequest(`${this.host}/internal/account/statement/reviews/${id}`, options);
  }

  deleteById(id, options = {}) {
    return this.makeRequest(`${this.host}/internal/account/statement/reviews/${id}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
